import { createFileRoute } from '@tanstack/react-router';
import { EmployeesGroupDetailsContainer } from 'src/features/employees-groups/containers/employees-group-details';

export const Route = createFileRoute(
  '/_layout/tenant/employees/groups/$groupToken/_layout',
)({
  component: EmployeesGroupDetailsContainer,
});
